<template>

  <svg
    t="1639130074033"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3985"
    width="64"
    height="64"
  ><path d="M376.9089195 511.98903867l334.2350451-318.28295435c11.91663967-11.32219885 11.91663967-29.72372224 0-41.06868668-11.91663967-11.34412151-31.22036416-11.34412151-43.13531635 0L312.8560354 490.86067596c-6.11978797 5.82636237-9.08777582 13.50771652-8.92251288 21.13848029-0.16610587 7.63160669 2.80188116 15.31296167 8.92251288 21.13932404l355.17537844 338.22243539c5.9562117 5.67290369 13.76067014 8.50935553 21.54573552 8.50935553 7.80277258 0 15.60891687-2.83645184 21.56681524-8.50935553 11.91663967-11.34327777 11.91663967-29.72372224 0-41.06784375L376.9089195 511.98903867z" p-id="3986" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconBack',
} as DefineComponent
</script>